import { InfoType } from 'interfaces';

const INFO: InfoType = {
  ABOUT: 'I am a frontend developer with 3 years of experience specializing in building high quality web applications using HTML, CSS and JavaScript. Strive to create an intuitive and responsive user interface with a focus on performance and cross-browser compatibility. Open to new technologies and willing to continuously learn. Looking for an opportunity to join a team where I can contribute to the development of interesting and innovative products.',
  SKILLS:
    'HTML, CSS, SASS, JS(6+), React, Redux (RTK), Angular (RxJS, NGRX), Apollo (reactive variables), TypeScript, JEST, Material UI, Ant, ESLint, Git, WebPack, Trello, Figma, Node Js (based on courses), MongoDB, Postman',
  EXPERINCE: [
    {
      TITLE: 'Freelance',
      PERIOD: 'Feb 2023 - Present',
      DESCRIPTION: 'Projects and startups on React, Angular.',
    },
    {
      TITLE: 'NOVOTECH.AI',
      PERIOD: 'Sep 2022 - Jan 2023',
      DESCRIPTION:
        'Changing the SPA design, optimization of API requests, working with DICOM files. React, TypeScript, Material UI, Redux Tool Kit, Scss, Figma',
    },
    {
      TITLE: 'NDA',
      PERIOD: 'Aug 2021 - June 2022',
      DESCRIPTION:
        'The project included working with React library, TypeScript, Sass preprocessor, Apollo graphic client, and creating Jest tests.',
    },
  ],
  EDUCATION: [
    {
      TITLE: 'React courses',
      PERIOD: 'Feb 2021 - Apr 2021',
      DESCRIPTION: 'free Online React courses conducted by The Rolling Scopes, Minsk.',
    },
    {
      TITLE: 'NodeJS courses',
      PERIOD: 'Oct 2020 - Nov 2020',
      DESCRIPTION: 'free Online Node JS courses conducted by The Rolling Scopes, Minsk.',
    },
    {
      TITLE: 'JavaScript courses',
      PERIOD: 'Sep 2019 - Jan 2020',
      DESCRIPTION:
        'Free Online Front-end JavaScript courses conducted by The Rolling Scopes, Minsk.',
    },
    {
      TITLE: 'Higher education',
      PERIOD: 'Sep 2012 - Jun 2017',
      DESCRIPTION:
        'Polotsk State University, specialty «Economics and management at the enterprise», qualification «Manager-economist»',
    },
    {
      TITLE: 'Technical school ',
      PERIOD: 'Sep 2003 - Jun 2007',
      DESCRIPTION:
        'Vitebsk State Polytechnic College, specialty «Software of information technologies», qualification «Technician programmer»',
    },
  ],
  LANGUAGES: [
    {
      TITLE: 'Russian',
      PERIOD: 'Native',
      DESCRIPTION: '',
    },
    {
      TITLE: 'English',
      PERIOD: 'Pre-Intermediate',
      DESCRIPTION: '',
    },
  ],
};

export default INFO;
